import { CreateMixin } from "@pdfking/reactivity/preact"

export const RootMixin = CreateMixin({
  data: {
    root: undefined as HTMLElement | undefined,
  },
  mounted(el: HTMLElement) {
    this.root = el
  },
})
